module.exports = __webpack_public_path__ + "img/golfoffice-no-text.8e019c8b.svg";